/* eslint-disable import/prefer-default-export */
import { workspaceConfirmUrl } from '../urls';
import refresh from '../refresh';

export async function postWorkspaceConfirm(workspaceId, legalName, aliasId, ipi, society) {
  const data = {
    workspace: workspaceId,
    legalName,
    alias: aliasId,
    ipi,
    society,
  };
  return refresh(async () => {
    const response = await fetch(workspaceConfirmUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
